<main>
    <app-navbar *ngIf="isLoggedIn()"></app-navbar>
    <div class="container-fluid">
        <router-outlet></router-outlet>
    </div>
</main>
<div *ngIf="isLoggedIn() && loading.status" class="loading d-flex justify-content-center align-items-center position-fixed top-0 w-100 h-100 start-0">
    <div>
        <div class="spinner-border text-white" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</div>
